<template>
  <div class="jiesuan">
    <div class="regular-header">
      <div class="regular-herder-container">
        <div class="closeicon" @click="closeJiesuan">×</div>
        <div class="flex start">
          <img :src="steeperGoodsInfo.original_img" :onerror="Imgerror" class="popup-shopimg" />
          <div class="popup-up-r">
            <div class="flex">
              <img :src="steeperGoodsInfo.original_img" :onerror="Imgerror" class="popup-shopimg-small" />
              <p class="size14 b500 popup-tle">{{ steeperGoodsInfo.goods_name }}</p>
            </div>
            <p class="popup-desc"></p>
          </div>
        </div>
      </div>

    </div>
    <div class="regular-box">
      <div class="height70px"></div>
      <div class="flex between regular" v-for="(item, index) in steeperGoodsInfo.spec" :key="item.id">
        <div class="flex regular-before">
          <p>{{ item.key_name }}</p>
          <p>余{{ item.store_count }}</p>
        </div>
        <div class="flex regular-after">
          <!-- <p
            @click="specification(item)"
            class="specification"
            :class="{ active1: item.isActive }"
            style="font-size: 14px; margin-right: 10px"
          >
            规格
          </p> -->

          <p @click="handleStepper(index)" v-if="currentStepper !== index">
            x{{ item.sum }}
          </p>
          <van-stepper v-model="item.sum" :min="0" :max="item.store_count" v-if="currentStepper == index" @blur="handleBlurSteeper" @focus="writeval"
            @plus="handlePlus" @minus="handleMinus" />
          <p>¥{{ item.price }}</p>
        </div>
      </div>
    </div>
    <PopupTabbar v-if="handleSj == 'zf'" v-model:total="total" v-model:sum="sum" v-model:fn="handlePay"></PopupTabbar>
    <div class="tabbar flex center" v-if="handleSj == 'jg'">
      <button @click="handleJiagou">加购</button>
    </div>
  </div>
</template>
<script>
import PopupTabbar from "../order/tabbar.vue";
import ajax from "@/utils/request.js";
import { showToast } from "vant";
export default {
  components: { PopupTabbar },
  props: {
    goodsInfo: {
      type: Object,
      default: () => { },
    },
    handleSj: {
      type: String,
      default: "",
    },
    is_concept: {
      type: Number,
      default: 1,
    },
    typeName: {
      type: String,
      default: "",
    }
  },
  data () {
    return {
      steeperGoodsInfo: {},
      sum: 0,
      total: 0,
      currentStepper: -1, //当前触发的步进器
      specJson: [], //上传的规格json
      oldval: 0,
      // specid: false,
    };
  },
  methods: {
    // specification(item) {
    //   item.isActive = !item.isActive;
    //   this.specid = item.isActive
    // },
    closeJiesuan () {
      this.$emit("closeJs");
    },
    handleStepper (index) {
      this.currentStepper = index;
    },
    writeval (event) {
      this.oldval = event.target.value;
    },
    handleBlurSteeper (event) {
      // console.log(event);
      const val = event.target.value;
      const obj = this.specJson.find((item) => {
        return (
          item.item_id === this.goodsInfo.spec[this.currentStepper].item_id
        );
      });
      if (obj) {
        obj.num = val;
      } else {
        this.specJson.push({
          item_id: this.goodsInfo.spec[this.currentStepper].item_id,
          price: this.goodsInfo.spec[this.currentStepper].price,
          num: val,
        });
      }
      this.sum = 0;
      this.specJson.forEach((item) => {
        this.sum += Number(item.num) * Number(item.price);
      });
      if (val <= 0 && this.oldval > 0) {
        this.total = 0
        // this.total--;
      } else if (val > 0 && this.oldval == 0) {
        this.total = val
        // this.total++;
      }

      this.currentStepper = -1;
    },
    //处理步进器添加的计算
    handlePlus () {
      const obj = this.specJson.find((item) => {
        return (
          item.item_id === this.goodsInfo.spec[this.currentStepper].item_id
        );
      });
      if (obj) {
        obj.num = Number(obj.num) + 1;
      } else {
        this.specJson.push({
          item_id: this.goodsInfo.spec[this.currentStepper].item_id,
          price: this.goodsInfo.spec[this.currentStepper].price,
          num: 1,
        });
      }
      this.sum = 0;
      this.specJson.forEach((item) => {
        this.sum = ((this.sum * 100) + ((Number(item.num) * Number(item.price)) * 100)) / 100;
      });
      this.total++;
    },
    //处理步进器减少的计算
    handleMinus () {
      const objIndex = this.specJson.findIndex((item) => {
        return (
          item.item_id === this.goodsInfo.spec[this.currentStepper].item_id
        );
      });
      this.specJson[objIndex].num--;
      this.sum = (this.sum * 100 - this.specJson[objIndex].price * 100) / 100;
      if (this.specJson[objIndex].num == 0) {
        this.specJson.splice(objIndex, 1);
      }
      this.total--;
    },
    //结算
    handlePay () {
      if (this.is_concept === 0) {
        this.$router.push({ path: "/shop/sense", query: { cate_id: 0 } });
        return;
      }
      // const data = {
      //   typeid: 1,
      //   address_type: 1,
      //   goods_id: this.goodsInfo.goods_id,
      //   spec: JSON.stringify(this.specJson),
      // };
      const json = [
        { sum: this.sum, total: this.total, ...this.steeperGoodsInfo },
      ];
      json.push({ type: 1 });
      sessionStorage.setItem("goodsinfo", JSON.stringify(json));
      this.$router.push("/shop/order/confirm");
      // ajax.post("order/makeorder", data).then((res) => {
      //   console.log(res);
      // });
    },
    //加购
    handleJiagou () {
      if (this.is_concept === 0) {
        // showToast("观念不匹配");
        this.$router.push({ path: '/shop/sense', query: { cate_id: 0 } })
        return;
      }
      const isEdit = this.typeName == 'cart' ? 1 : ''
      const spectArr = []
      const data = {
        is_edit: isEdit,
        goods_id: this.steeperGoodsInfo.goods_id,
        spec: null
      }
      if (isEdit == 1) {
        this.steeperGoodsInfo.spec.forEach(item => {
          if (item.sum > 0) {
            spectArr.push(item)
          }
        })
        spectArr.forEach(item => {
          item.num = item.sum
        })
        data.spec = JSON.stringify(spectArr)
      } else {
        data.spec = JSON.stringify(this.specJson)
      }
      // const data = {
      //   goods_id: this.steeperGoodsInfo.goods_id,
      //   spec: JSON.stringify(this.specJson),
      //   is_edit: this.typeName == 'cart' ? 1 : '',
      // };
      const url = 'cart/addcart'
      ajax.post(url, data).then((res) => {
        if (res.errcode === 1) {
          showToast(res.message);
        }

        this.$emit("closeJs");
      });
    },
  },
  created () {
    // console.log(this.goodsInfo);
    this.steeperGoodsInfo = this.goodsInfo;
    // console.log("steeperGoodsInfo", this.steeperGoodsInfo);
  },
  watch: {
    deep: true,
    handleSj () {
      this.currentStepper = -1;
      this.sum = 0;
      this.total = 0;
      this.specJson = [];

      this.steeperGoodsInfo.spec.forEach((item) => {
        item.sum = 0;
      });
    },
    goodsInfo (newval) {
      // console.log(newval);
      this.currentStepper = -1;
      this.sum = 0;
      this.total = 0;
      this.specJson = [];
      this.steeperGoodsInfo = newval;
      if (this.typeName == 'cart' || this.typeName == 'again') {
        return
      }
      this.steeperGoodsInfo.spec.forEach((item) => {
        item.sum = 0;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.jiesuan{
  height: 75vh;
  border-top-left-radius: 30px;

  .regular-header{
    position: fixed;
    top: 10vh;
    left: 0;
    width: 100%;
    padding: 10px 0;
    background-color: #fff;
    .regular-herder-container{
      padding: 0 15px;
    }
  }
}

.closeicon {
  position: absolute;
  font-size: 32px;
  line-height: 28px;
  top: 0;
  right: 15px;
}
.specification {
  border-radius: 10px;
  padding: 3px 7px !important;
}
.active1 {
  background: #f6f6f6;
}

.popup {
  padding: 6.4vw 4vw 17.0667vw;
  .popup-up-r {
    padding-left: 2.6667vw;
  }
  .popup-shopimg {
    width: 26.6667vw;
    height: 26.6667vw;
    object-fit: contain;
  }
  .popup-shopimg-small {
    display: block;
    width: 4.8vw;
    height: 4.8vw;
    object-fit: contain;
    border-radius: 50%;
    margin-right: 1.0667vw;
  }
  .popup-tle {
    width: 53.3333vw;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .regular-box {
    padding-top: calc(5.3333vw + 25px);
    padding-bottom: 80px ;
  }
  .regular {
    margin-bottom: 3.2vw;
  }
  .regular-before {
    p {
      &:first-child {
        width: 26.1333vw;
        height: 8vw;
        line-height: 8vw;
        text-align: center;
        color: #999999;
        font-size: 14px;
        background: #f6f6f6;
        border-radius: 0.5333vw;
      }
      &:last-child {
        color: #999999;
        font-size: 12px;
        margin-left: 2.6667vw;
      }
    }
  }
  .regular-after {
    p {
      &:first-child {
        padding: 1.3333vw 0.8vw;
        text-align: center;
        border: 1px solid rgba(204, 204, 204, 0.2);
      }
      &:last-child {
        margin-left: 5.3333vw;
      }
    }
  }
}
.tabbar {
  position: fixed;
  height: 17.0667vw;
  padding: 0 4vw;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  box-shadow: 0px -1px 20px 0px rgba(0, 0, 0, 0.08);
  justify-content: flex-end;
  button {
    width: 23.2vw;
    height: 10.6667vw;
    line-height: 10.6667vw;
    text-align: center;
    background: #ffffff;
    border-radius: 5.6vw;
    font-size: 14px;
    color: #e30000;
    border: 1px solid #e30000;
  }
}

</style>